import { Injectable } from '@angular/core';
import { RestfulService } from '../rest/restful';
import { Models } from '@ibexfusion/models';
import { RestProvider, RestService } from '../rest/rest.service';

@Injectable({
  providedIn: 'root'
})
export class GroupHasContentService extends RestfulService<Models.GroupHasContent> {

  constructor(private restService: RestService) {
    super(Models.GroupHasContent);

    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('group-has-contents');
  }
}
